import { TDevice } from '../entities/ric003'
import { DeviceData } from '../models/deviceState'
import { CoordinateType, DeviceMode } from '../common/enums'
import { determineProductType } from './products'

export function convertToDeviceData(device: TDevice): DeviceData {
  const RIC_DEFAULT_PIN = '*****'

  return {
    id: device.WISOL_ID,
    sigfoxId: device.WISOL_ID,
    deviceId: device.DEVICE_ID,
    info: {
      deviceId: device.DEVICE_ID,
      wisolId: device.WISOL_ID,
      wisolPac: device.WISOL_PAC,
      serialNumber: device.SERIAL_NUMBER,
      hardwareVersion: device.HW_VERSION,
      sigfoxReg: device.SIGFOX_REG,
      productType: determineProductType(device.DEV_PRODUCT_ID),
      dateCode: device.DATE_CODE,
      deviceKey: device.DEV_KEY,
      messageSntsId: device.MSG_SNTS_ID,
      runId: device.RUN_ID,
    },
    config: {
      firmwareVersion: -1,
      device: {
        name: '',
        configId: -1,
        configFlags: -1,
        mode: DeviceMode.Unknown,
        pin: RIC_DEFAULT_PIN,
      },
      site: {
        name: '',
        code: '',
      },
      frequency: {
        snts: -1,
        schd: -1,
      },
      location: {
        description: '',
        coordinateType: CoordinateType.NotSet,
        coord: {
          ns: 0,
          ew: 0,
          z: 0,
          gridZone: '',
        },
      },
      sensors: {},
    },
    state: {
      readings: {
        battery: -1,
        temperature: -1,
      },
      alerts: {
        batteryLowWarning: false,
        batteryLowShutdown: false,
      },
      flags: {
        enableSntsBatteryReading: false,
        enableSchdTemperatureReading: false,
        inConfigMode: false,
        inScheduledStartMode: false,
      },
      test: {
        message: '',
      },
    },
    tracking: {
      timestamps: {
        testMessage: 0,
        sntsMessage: 0,
        schdMessage: 0,
        deviceConfig1: 0,
        deviceConfig2: 0,
        deviceConfig3: 0,
        deviceConfig4: 0,
        deviceConfig5: 0,
        sensorConfig1: 0,
      },
      last: {
        rawMessageId: -1,
        update: 0,
      },
      configUpdate: {
        active: false,
        lastUpdate: 0,
        configured: false,
      },
    },
    readings: {},
  }
}
